import fr from 'facet-rest';
import React from 'react';
import { noop } from 'Helpers/PropTypes';
import {
  SelectScenarioContextProvider,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/SelectScenarioContext';
import {
  RoadmapExecutiveSummaryContent,
} from 'Views/Page/Content/Templates/RoadmapExecutiveSummaryTemplate/RoadmapExecutiveSummary/RoadmapExecutiveSummaryContent';
import { RightColumnProvider } from 'Context/RightColumnContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

export const RoadmapExecutiveSummaryLayout = ({ onAgentReview = noop, resource, showHeaderAndFooter = true }) => {
  const { loadPageContentLink } = usePageContentContext();

  const onSelectSuccess = async () => {
    // After we submit the scenario successfully we need to make sure we get taken into the scenario wizard.
    // We will take you to the decision step which will then direct you to the correct place
    await resource.withRelationship(fr.relationships.scenarioSelectionDecisionStep.name,
      (decisionStepRel) => loadPageContentLink(decisionStepRel.link('related')),
      () => null);
  };

  return (
    <SelectScenarioContextProvider onAgentReview={onAgentReview} onSelectSuccess={onSelectSuccess}>
      <RightColumnProvider>
        <RoadmapExecutiveSummaryContent resource={resource} showHeaderAndFooter={showHeaderAndFooter} />
      </RightColumnProvider>
    </SelectScenarioContextProvider>
  );
};
